'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

const LEGAL_LINKS = [
  { href: '/legal/terms/', label: 'Terms of Use' },
  { href: '/legal/community/', label: 'Community Guidelines' },
  { href: '/legal/privacy/', label: 'Privacy Policy' },
  { href: '/legal/marketplace/', label: 'Marketplace policy' },
  { href: '/legal/data-deletion/', label: 'Data deletion' },
  { href: '/legal/cookies/', label: 'Cookie Policy' },
  { href: '/legal/data-sources/', label: 'Data sources' },
] as const;

export function LegalPageNav() {
  const pathname = usePathname() ?? '';

  return (
    <nav className="legal-page__nav" aria-label="Legal documents">
      <ul className="legal-page__nav-list">
        {LEGAL_LINKS.map((item) => {
          const base = item.href.replace(/\/$/, '');
          const active = pathname === base || pathname === item.href || pathname.startsWith(`${base}/`);
          return (
            <li key={item.href}>
              <Link
                href={item.href}
                className={`legal-page__nav-link${active ? ' legal-page__nav-link--active' : ''}`}
                aria-current={active ? 'page' : undefined}
              >
                {item.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
